import * as Sentry from '@sentry/react';
import { FC, useEffect } from 'react';
import { FallbackProps } from 'react-error-boundary';
import Logo from '../assets/images/logo_crono.png';
import { ReactComponent as ErrorGear } from '../assets/images/Error_gear.svg';
import { getConsoleOutput } from './index';
import { isLocal } from 'utils/uiHelpers';
import { Button } from '@crono-one/design-system';

const FullpageErrorFallBack: FC<FallbackProps> = ({
  error,
  resetErrorBoundary,
}) => {
  useEffect(() => {
    if (!isLocal()) {
      const consoleRecords = getConsoleOutput();

      Sentry.withScope((scope) => {
        scope.setTag('errorType', 'fatal-app-error');
        scope.setLevel('fatal');
        scope.setContext('consoleRecords', {
          records: consoleRecords,
          recordCount: consoleRecords?.length || 0,
        });
        scope.setExtra('errorBoundary', 'FullpageErrorFallback');

        Sentry.captureException(error);
      });
    }
  }, [error]);

  return (
    <div className="flex flex-col items-center h-full p-8">
      <img src={Logo} alt="logo" className="w-25" />
      <div className="flex flex-col items-center h-full justify-center gap-y-4">
        <div>
          <ErrorGear />
        </div>
        <p className="text-2xl font-bold text-center">
          Oops! System Recovery in Progress
        </p>

        <p className="font-medium text-gray-700 text-center">
          Sorry, the system is currently down.
          <br />
          We are already working on fixing the problem.
        </p>

        <Button tone="primary" onClick={resetErrorBoundary}>
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default FullpageErrorFallBack;
